<template>
  <layout-main-inner title="调拨单">
    <layout-card-wrap>
      <allocate-table-all />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import AllocateTableAll from './busi/allocate-table-all.vue'
// import AllocateTableOut from './busi/allocate-table-out.vue'

export default {
  name: 'AllocateList',
  components: { AllocateTableAll },
  props: {},
  data() {
    return {
      activeTab: '1'
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: { }
}
</script>
